


// import React, { useEffect, useRef, useState } from 'react'
// import '../css/layout.css'
// import css from '../Modulecss/Home.module.css'
// import axios from 'axios'
// import { Link, NavLink, useHistory, useLocation } from 'react-router-dom'
// import Swal from 'sweetalert2'
// import Rightcontainer from '../Components/Rightcontainer'
// import { useDispatch } from 'react-redux'
// import BetCard from './BetCard'
// import RunningCard from './RunningCard'
// import Header from '../Components/Header'
// import io from '../Components/socket'
// import Spinner from 'react-bootstrap/Spinner'
// import Button from 'react-bootstrap/Button'
// import Landing from './Landing'
// import { IoIosInformationCircleOutline } from 'react-icons/io'
// import BotTable from './BotTable'
// import socket from '../Components/socket'
// import { Widget, addResponseMessage, addUserMessage, setQuickButtons } from "react-chat-widget";
// import { BsLightningChargeFill, BsFire, BsDice5 } from 'react-icons/bs'
// import { MdOutlineSportsEsports } from 'react-icons/md'

// export default function Homepage({ walletUpdate }) {
//   const history = useHistory()
//   let userID = useRef()
//   const isMounted = useRef(true)
//   let str
//   /// user details start

//   const [user, setUser] = useState()
//   const [created, setCreated] = useState([])
//   const [challangeReqRun, setChallangeReqRun] = useState(false)

//   const [game_amount, setGame_amt] = useState()

//   const [userAllData, setUserAllData] = useState()

//   const [gameData, setGameData] = useState({})

//   const [submitProcess, setProcess] = useState(true)
//   const [isLoading, setIsloading] = useState(false)
//     const addsetting = localStorage.getItem('sitSetting')
//   const [addCaseSetting, setaddCaseSetting] = useState()

//     // const addCaseSetting = JSON.parse(addsetting)


//   const access_token = localStorage.getItem('token')

//   useEffect(() => {
//     socket.emit('websetting')
//   }, [])
//   useEffect(() => {
//     socket.on("websettingGet", (data) => {
//       localStorage.setItem("sitSetting", JSON.stringify(data));
//       setaddCaseSetting(data);
//     });

//     socket.on("recive-msg", (msgs) => {
//       if (msgs?.sender !== user?._id) addResponseMessage(msgs.text);
//     });
//   }, []);
//   const role = async () => {
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//     await axios
//       .get(`https://api.rrludo.in/me`, { headers })
//       .then(res => {
//         setUser(res.data._id)
//         setUserAllData(res.data)
//         userID.current = res.data._id
//         setMount(true)
//       })
//       .catch(e => {
//         if (e.response.status == 401) {
//           localStorage.removeItem('token')
//           // window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e.response.status == 400 || e.response.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }

//   /// user details end
//   // console.log(useLocation().pathname.split('/')[2], '  useLocation().pathname')
//   const [game_type, setGame_type] = useState(
//     useLocation().pathname.split('/')[2]
//   )
//   const [game_type2, setGame_type2] = useState(
//     useLocation().pathname.split('/')[2]
//   )
//   const [Game_Ammount, setGame_Ammount] = useState('')

//   //   console.log(game_type);

//   const ChallengeCreate = e => {
//     setIsloading(true)
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .post(
//         'https://api.rrludo.in/challange/create',
//         {
//           Game_Ammount,
//           Game_type: game_type
//         },
//         { headers }
//       )
//       .then(res => {
//         setGame_amt(res?.data?.data?.Game_Ammount)

//         if (res.data.status == false) {
//           setIsloading(false)
//           Swal.fire({
//             title: res.data.msg,
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (res.data.msg === 'you have already enrolled') {
//           setIsloading(false)
//           Swal.fire({
//             title: 'You have already enrolled',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (res.data.msg === 'You can set maximum 2 battle.') {
//           setIsloading(false)
//           Swal.fire({
//             title: 'You can set maximum 2 battle.',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (res.data.msg === 'Insufficient balance') {
//           setIsloading(false)
//           Swal.fire({
//             title: 'Insufficient balance',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (
//           res.data.msg ===
//           'Game amount should be Greater then 50 and less then 50000'
//         ) {
//           setIsloading(false)
//           Swal.fire({
//             title: 'Game amount should be Greater then 50 and less then 50000',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (res.data.msg === 'Set Battle in denomination of 50') {
//           setIsloading(false)
//           Swal.fire({
//             title: 'Set Battle in denomination of 50',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else if (res.data.msg === 'Technical Issue, Try after an hour!') {
//           setIsloading(false)
//           Swal.fire({
//             title: 'Technical Issue, Try after an hour!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else {
//           setIsloading(false)
//           setGame_Ammount("");
//           // Allgames();
//           // io.emit("gameCreated");
//         }
//       })
//       .catch(e => {
//         setIsloading(false)
//         if (e?.response?.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e?.response?.status == 400 || e?.response?.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//         console.log(e)
//       })
//   }

//   const [allgame, setallgame] = useState([])
//   const [mount, setMount] = useState(false)
//   const [ALL, setALL] = useState()
//   const [runningGames, setRunningGames] = useState([])
//   const [ownRunning, setOwnRunning] = useState([])

//   const Allgames = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//     axios
//       .get('https://api.rrludo.in/challange/all', { headers })
//       .then(res => {
//         let owenedCreated = [],
//           remainingGame = []
//         res.data.forEach(function (ele) {
//           if (
//             ele.Created_by._id == user &&
//             (ele.Status == 'new' || ele.Status == 'requested')
//           ) {
//             owenedCreated.push(ele)
//           } else {
//             remainingGame.push(ele)
//           }
//         })
//         setCreated(owenedCreated)
//         setallgame(remainingGame)
//       })
//       .catch(e => {
//         if (e?.response?.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e?.response?.status == 400 || e?.response?.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }

//   const runningGame = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .get('https://api.rrludo.in/challange/running/all', { headers })
//       .then(res => {
//         let owenedRunning = [],
//           remainingRunning = []
//         res.data.forEach(function (ele) {
//           if (ele.Created_by && ele.Accepetd_By)
//             if (
//               ele.Created_by?._id == userID.current ||
//               ele.Accepetd_By?._id == userID.current
//             ) {
//               owenedRunning.push(ele)
//             } else {
//               remainingRunning.push(ele)
//             }
//         })
//         setOwnRunning(owenedRunning)
//         setRunningGames(remainingRunning)
//       })
//       .catch(e => {
//         console.log('errror', e)
//         if (e.response?.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           // window.location.reload()
//           //    setTimeout(() => {
//           // //  history.push("/login")
//           // }, 500);
//         }
//         if (e.response?.status == 400 || e.response?.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }




//   function winnAmount(gameAmount) {
//     let profit = 0;

//     const commissionLudo = addCaseSetting?.commissionRangeludo || 10; // for 50–500
//     const commissionAbove500 = addCaseSetting?.commissionRange2 || 5; // for >500
//     if (gameAmount >= 50 && gameAmount <= 450) {
//       profit = (gameAmount * commissionLudo) / 100; // use commissionRangeludo
//     } else if (gameAmount > 450) {
//       profit = (gameAmount * commissionAbove500) / 100; // use commissionRange2
//     }

//     return gameAmount - profit;
//   }



//   useEffect(() => {
//     io.on('gamelist', data => {

//       let owenedCreated = [],
//         remainingGame = []
//       data.forEach(function (ele) {
//         if (ele.Created_by)
//           if (
//             ele.Created_by._id == userID.current &&
//             (ele.Status == 'new' || ele.Status == 'requested')
//           ) {
//             owenedCreated.push(ele)
//           } else {
//             remainingGame.push(ele)
//           }
//       })
//       // console.log('own',owenedCreated,'remiain',remainingGame);
//       setCreated(owenedCreated)
//       setallgame(remainingGame)
//     })

//     io.on('resultUpdateReq', data => {
//       // console.log('resultUpdateReq')
//       let owenedRunning = [],
//         remainingRunning = []
//       data.forEach(function (ele) {
//         if (ele.Created_by && ele.Accepetd_By)
//           if (
//             ele.Created_by._id == userID.current ||
//             ele.Accepetd_By._id == userID.current
//           ) {
//             owenedRunning.push(ele)
//           } else {
//             remainingRunning.push(ele)
//           }
//       })
//       setOwnRunning(owenedRunning)
//       setRunningGames(remainingRunning)
//       walletUpdate()
//     })
//     io.on('startAcepptor', data => {
//       // console.log('startAcepptor',data)
//       let owenedCreated = [],
//         remainingGame = []
//       data.forEach(function (ele) {
//         if (ele.Created_by)
//           if (
//             ele.Created_by._id == userID.current &&
//             (ele.Status == 'new' || ele.Status == 'requested')
//           ) {
//             owenedCreated.push(ele)
//           } else {
//             remainingGame.push(ele)
//           }
//       })
//       setCreated(owenedCreated)
//       setallgame(remainingGame)
//       walletUpdate()
//     })

//     io.on('acceptor_seen', data => {
//       // console.log('acceptor_seen',data)
//       let owenedCreated = [],
//         remainingGame = []
//       data.openBattle.forEach(function (ele) {
//         if (ele.Created_by)
//           if (
//             ele.Created_by._id == userID.current &&
//             (ele.Status == 'new' || ele.Status == 'requested')
//           ) {
//             owenedCreated.push(ele)
//           } else {
//             remainingGame.push(ele)
//           }
//       })
//       setCreated(owenedCreated)
//       setallgame(remainingGame)
//       let owenedRunning = [],
//         remainingRunning = []
//       data.runningBattle.forEach(function (ele) {
//         if (ele.Created_by && ele.Accepetd_By)
//           if (
//             ele.Created_by._id == userID.current ||
//             ele.Accepetd_By._id == userID.current
//           ) {
//             owenedRunning.push(ele)
//           } else {
//             remainingRunning.push(ele)
//           }
//       })
//       setOwnRunning(owenedRunning)
//       setRunningGames(remainingRunning)
//       walletUpdate()
//     })
//   }, [io])

//   useEffect(() => {
//     let access_token = localStorage.getItem('token')
//     access_token = localStorage.getItem('token')
//     if (!access_token) {
//       window.location.reload()
//       setTimeout(() => {
//         //  history.push("/login")
//       }, 500)
//     }
//     role()
//     if (mount) {
//       Allgames()
//       runningGame()
//     }
//     return () => {
//       role()
//     }
//   }, [mount])
//   //accept Challange

//   const AcceptChallang = id => {
//     if (str == 1) {
//       Swal.fire({
//         title: 'Other request in process',
//         icon: 'warning',
//         confirmButtonText: 'OK'
//       })
//     }
//     str = 1
//     const access_token = localStorage.getItem('token')

//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .put(
//         `https://api.rrludo.in/challange/accept/${id}`,
//         {
//           Accepetd_By: headers,
//           Acceptor_by_Creator_at: Date.now()
//         },
//         {
//           headers
//         }
//       )
//       .then(res => {
//         setGameData({
//           accept_by: res.data.Accepetd_By,
//           created_by: res.data.Created_by
//         })

//         str = 0
//         if (res.data.status === false) {
//           Swal.fire({
//             title: res.data.msg,
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//         if (res.data.msg === 'you have already enrolled') {
//           Swal.fire({
//             title: 'You have already enrolled',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//         if (res.data.msg === 'Insufficient balance') {
//           Swal.fire({
//             title: 'Insufficient balance',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         } else {
//           // Allgames(res.data)
//         }
//       })
//       .catch(e => {
//         console.log(e)
//         if (e.response.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e.response.status == 400 || e.response.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }

//   //reject Game
//   const RejectGame = id => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .put(
//         `https://api.rrludo.in/challange/reject/${id}`,
//         {
//           Accepetd_By: null,
//           Status: 'new',
//           Acceptor_by_Creator_at: null
//         },
//         { headers }
//       )
//       .then(res => {
//         // io.emit("gameRejected");
//       })
//       .catch(e => {
//         console.log(e)
//         if (e.response.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e.response.status == 400 || e.response.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }

//   //delete
//   const deleteChallenge = _id => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .delete(`https://api.rrludo.in/challange/delete/${_id}`, {
//         headers
//       })
//       .then(res => {
//         if (res.data.status == false) {
//           Swal.fire({
//             title: res.data.msg,
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//         // io.emit("deleteGame", _id);
//       })
//       .catch(e => {
//         if (e?.response?.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e.response.status == 400 || e.response.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//       })
//   }

//   ///challange/running/update/

//   const updateChallenge = _id => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     axios
//       .put(
//         `https://api.rrludo.in/challange/running/update/${_id}`,
//         {
//           Acceptor_seen: true
//         },
//         { headers }
//       )
//       .then(res => {
//         // io.emit("game_seen");
//       })
//       .catch(e => {
//         if (e.response.status == 401) {
//           localStorage.removeItem('token')
//           localStorage.removeItem('token')
//           window.location.reload()
//           setTimeout(() => {
//             //  history.push("/login")
//           }, 500)
//         }
//         if (e.response.status == 400 || e.response.status == 429) {
//           Swal.fire({
//             title: 'Please refresh!',
//             icon: 'warning',
//             confirmButtonText: 'OK'
//           })
//         }
//         console.log(e)
//       })
//   }

//   // const [roomCode, setRoomCode] = useState()

//   const getPost = async Id => {
//     if (
//       game_type === 'Ludo Classics' ||
//       game_type === 'Ludo 1 Goti' ||
//       game_type === 'Ludo Ulta' ||
//       // game_type === "Ludo Popular" ||
//       game_type === 'Ludo Host'
//     ) {
//       if (submitProcess) {
//         setProcess(false)
//         setChallangeReqRun(true)

//         const access_token = localStorage.getItem('token')

//         const headers = {
//           authorization: `Bearer ${access_token}`
//         }

//         axios
//           .patch(
//             `https://api.rrludo.in/challange/requested/running/${game_type}/` +
//             Id,
//             {},
//             { headers }
//           )
//           .then(res => {
//             setProcess(true)
//             setChallangeReqRun(false)
//             if (res.data.status == false) {
//               Swal.fire({
//                 title: res.data.msg,
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             } else {
//               localStorage.setItem('timeOver', 'timeStart')
//               history.push(`/viewgame1/${Id}`, {
//                 prevPath: window.location?.pathname
//               })
//             }
//           })
//           .catch(e => {
//             setProcess(true)
//             setChallangeReqRun(false)
//             if (e?.response?.status == 401) {
//               Swal.fire({
//                 title: 'Somthing wrong',
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             } else {
//               Swal.fire({
//                 title: 'Please refresh!',
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             }
//           })
//       }

//     } else if (
//       game_type === 'LudoSnake' ||
//       game_type === 'Ludo Popular' ||
//       game_type === 'ludoClassicManual'
//     ) {
//       if (submitProcess) {
//         setProcess(false)
//         setChallangeReqRun(true)

//         const access_token = localStorage.getItem('token')

//         const headers = {
//           authorization: `Bearer ${access_token}`
//         }

//         axios
//           .patch(
//             'https://api.rrludo.in/challange/requested/running/' + Id,
//             {},
//             { headers }
//           )
//           .then(res => {
//             setProcess(true)
//             setChallangeReqRun(false)
//             if (res.data.status == false) {
//               Swal.fire({
//                 title: res.data.msg,
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             } else {
//               localStorage.setItem('timeOver', 'timeStart')
//               history.push(`/viewgame1/${Id}`, {
//                 prevPath: window.location?.pathname
//               })
//             }
//           })
//           .catch(e => {
//             setProcess(true)
//             setChallangeReqRun(false)
//             if (e?.response?.status == 401) {
//               Swal.fire({
//                 title: 'Somthing wrong',
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             } else {
//               Swal.fire({
//                 title: 'Please refresh!',
//                 icon: 'warning',
//                 confirmButtonText: 'OK'
//               })
//             }
//           })
//       }
//     }
//   }

//   const [siteSetting, setsiteSetting] = useState([])

//   useEffect(() => {
//     const items = JSON.parse(localStorage.getItem('sitSetting'))
//     if (items) {
//       setsiteSetting(items)
//     }
//   }, [])

//   const [botTable, setBotTable] = useState([]);

//   const getRandomSet = async () => {
//     try {
//       const access_token = localStorage.getItem("token");

//       const res = await axios.get("https://api.rrludo.in/randomset", {
//         headers: { Authorization: `Bearer ${access_token}` },
//       });

//       if (res.data.status === "success") {
//         setBotTable(res.data.players);
//       }
//     } catch (err) {
//       console.error("Error fetching random set:", err);
//     }
//   };

//   useEffect(() => {
//     getRandomSet();
//   }, []);

//   // --- UI THEME STYLES (DREAM11 DARK) ---
//   const styles = {
//     mainBg: {
//       background: 'radial-gradient(circle at top, #1a1a1a, #0a0a0a)',
//       minHeight: '100vh',
//       // paddingTop: '80px',
//       color: '#fff',
//       fontFamily: "'Inter', sans-serif"
//     },
//     ticker: {
//       background: 'rgba(215, 25, 32, 0.1)',
//       borderBottom: '1px solid #333',
//       padding: '10px 0',
//       color: '#FF3131',
//       fontSize: '13px',
//       fontWeight: '600'
//     },
//     createCard: {
//         background: 'linear-gradient(145deg, #1e1e1e 0%, #121212 100%)',
//         borderRadius: '24px',
//         padding: '25px',
//         border: '1px solid #333',
//         boxShadow: '0 15px 30px rgba(0,0,0,0.5)',
//         marginBottom: '30px'
//     },
//     inputWrapper: {
//         background: '#000',
//         borderRadius: '15px',
//         padding: '5px 5px 5px 20px',
//         display: 'flex',
//         alignItems: 'center',
//         border: '1px solid #222',
//         marginTop: '15px'
//     },
//     setBtn: {
//         background: 'linear-gradient(180deg, #FF3131 0%, #BA0000 100%)',
//         color: '#fff',
//         border: 'none',
//         borderRadius: '12px',
//         padding: '12px 25px',
//         fontWeight: '800',
//         fontSize: '14px',
//         marginLeft: '10px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         cursor: 'pointer'
//     },
//     sectionHeading: {
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         fontSize: '15px',
//         fontWeight: '800',
//         textTransform: 'uppercase',
//         letterSpacing: '1px',
//         marginBottom: '20px',
//         paddingLeft: '10px',
//         borderLeft: '4px solid #FF3131'
//     }
//   };

//   return (
//     <>
//       <Header user={userAllData} />
//       <div className='leftContainer' style={styles.mainBg}>
//         <div className='pt-4 mt-5 Orher_page_main_section'>
          
//           {/* Ticker Banner */}
//           <div style={styles.ticker}>
//             <marquee scrollamount="5">
//               <BsLightningChargeFill className="me-2" /> 
//               {siteSetting?.ludoClassicsMsg || "Welcome to Brothers Ludo - Real Games, Real Wins!"} 
//               • 24x7 SUPPORT • INSTANT WITHDRAWAL ACTIVE
//             </marquee>
//           </div>

//           <div className='container py-4'>
//             <div className='row'>
//               <div className='col-lg-8 col-md-12'>
                
//                 {/* Rules Link */}
//                 <div className='d-flex justify-content-end mb-3'>
//                   <Link to="/Rules" style={{background: '#1e1e1e', color: '#fff', padding: '6px 15px', borderRadius: '20px', fontSize: '12px', textDecoration: 'none', border: '1px solid #333'}}>
//                     RULES
//                   </Link>
//                 </div>

//                 {/* Create Battle Blade */}
//                 {(siteSetting?.gameSearch) && (
//                   <div style={styles.createCard}>
//                       <h5 className="fw-bold mb-0">Open Battle !</h5>
//                       <div style={styles.inputWrapper}>
//                           <span style={{color: '#4CAF50', fontWeight: '900', fontSize: '18px'}}>₹</span>
//                           <input
//                               type="text"
//                               placeholder="Enter Amount"
//                               inputMode="numeric"
//                               value={Game_Ammount}
//                               onChange={e => setGame_Ammount(e.target.value)}
//                               style={{background: 'transparent', border: 'none', color: '#fff', width: '100%', padding: '10px', outline: 'none', fontWeight: '700'}}
//                           />
//                           {isLoading ? (
//                               <div className="px-4"><Spinner size="sm" animation="border" variant="danger" /></div>
//                           ) : (
//                               <button style={styles.setBtn} onClick={(e) => { e.preventDefault(); ChallengeCreate(); }}>
//                                   SET
//                               </button>
//                           )}
//                       </div>
//                   </div>
//                 )}

//                 {/* Open Battles List */}
//                 <div className="mb-5">
//                   <div style={styles.sectionHeading}>
//                       <span><BsFire color="#FF3131" className="me-2"/> Open Battles</span>
//                   </div>
//                   <div className="battle-stack">
//                       {created && created.map(allgame => 
//                         allgame.Game_type == game_type && (
//                           <BetCard
//                             key={allgame._id}
//                             allgame={allgame}
//                             user={user}
//                             deleteChallenge={deleteChallenge}
//                             getPost={getPost}
//                             RejectGame={RejectGame}
//                             challangeReqRun={challangeReqRun}
//                             winnAmount={winnAmount}
//                             AcceptChallang={AcceptChallang}
//                             updateChallenge={updateChallenge}
//                           />
//                         )
//                       )}
//                       {allgame && allgame.map(allgame => 
//                         (allgame.Status == 'new' || (allgame.Status == 'requested' && (user == allgame.Created_by._id || user == allgame?.Accepetd_By?._id)) || (allgame?.Status == 'running' && user == allgame?.Accepetd_By?._id && allgame.Acceptor_seen == false)) &&
//                         allgame.Game_type == game_type && (
//                           <BetCard
//                             key={allgame._id}
//                             allgame={allgame}
//                             user={user}
//                             deleteChallenge={deleteChallenge}
//                             getPost={getPost}
//                             RejectGame={RejectGame}
//                             winnAmount={winnAmount}
//                             AcceptChallang={AcceptChallang}
//                             updateChallenge={updateChallenge}
//                           />
//                         )
//                       )}
//                   </div>
//                 </div>

//                 {/* Running Battles List */}
//                 <div className="mb-5">
//                   <div style={styles.sectionHeading}>
//                       <span><MdOutlineSportsEsports color="#FF3131" className="me-2" size={20}/> Running Battles</span>
//                   </div>
//                   <div className="battle-stack">
//                       {ownRunning && ownRunning.map(runnig => {
//                         if (((user == runnig.Accepetd_By._id ? (runnig.Status === 'running' && user == runnig.Accepetd_By._id && runnig.Acceptor_seen == true) || runnig.Status === 'pending' : (runnig.Status === 'running' && user == runnig.Created_by._id) || runnig.Status === 'pending') || runnig.Status == 'conflict') && runnig.Game_type == game_type)
//                         return (
//                           <RunningCard
//                             key={runnig._id}
//                             runnig={runnig}
//                             user={user}
//                             winnAmount={winnAmount}
//                           />
//                         )
//                       })}

//                       {runningGames && runningGames.map(runnig => {
//                         if ((user == runnig.Accepetd_By._id || user == runnig.Created_by._id ? user == runnig.Accepetd_By._id ? (runnig.Status === 'running' && user == runnig.Accepetd_By._id && runnig.Acceptor_seen == true) || (runnig.Status === 'pending' && runnig.Acceptor_status == null) : (runnig.Status === 'running' && user == runnig.Created_by._id) || (runnig.Status === 'pending' && runnig.Creator_Status == null) : runnig.Status === 'running' || runnig.Status === 'pending') && runnig.Game_type == game_type)
//                         return (
//                           <RunningCard
//                             key={runnig._id}
//                             runnig={runnig}
//                             user={user}
//                             winnAmount={winnAmount}
//                           />
//                         )
//                       })}

//                       {botTable && botTable.map((running, index) => (
//                         <BotTable key={index} running={running} winnAmount={winnAmount} />
//                       ))}
//                   </div>
//                 </div>

//               </div>

//               {/* Sidebar */}
//               <div className='col-lg-4 d-none d-lg-block'>
//                 <Rightcontainer />
//               </div>
//             </div>
//           </div>

//         </div>
//       </div>

//       <style>{`
//         .battle-stack {
//             display: flex;
//             flex-direction: column;
//             gap: 12px;
//         }
//         input::placeholder { color: #444; font-weight: 500; }
//         .Orher_page_main_section { min-height: 80vh; }
//         marquee { display: block; width: 100%; }
//       `}</style>
//     </>
//   )
// }


import React, { useEffect, useRef, useState } from 'react'
import '../css/layout.css'
import css from '../Modulecss/Home.module.css'
import axios from 'axios'
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import Rightcontainer from '../Components/Rightcontainer'
import { useDispatch } from 'react-redux'
import BetCard from './BetCard'
import RunningCard from './RunningCard'
import Header from '../Components/Header'
import io from '../Components/socket'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Landing from './Landing'
import { IoIosInformationCircleOutline } from 'react-icons/io'
import BotTable from './BotTable'
import socket from '../Components/socket'
import { Widget, addResponseMessage, addUserMessage, setQuickButtons } from "react-chat-widget";
import { BsLightningChargeFill, BsFire, BsDice5 } from 'react-icons/bs'
import { MdOutlineSportsEsports } from 'react-icons/md'

export default function Homepage({ walletUpdate }) {
  const history = useHistory()
  let userID = useRef()
  const isMounted = useRef(true)
  let str

  const [user, setUser] = useState()
  const [created, setCreated] = useState([])
  const [challangeReqRun, setChallangeReqRun] = useState(false)
  const [game_amount, setGame_amt] = useState()
  const [userAllData, setUserAllData] = useState()
  const [gameData, setGameData] = useState({})
  const [submitProcess, setProcess] = useState(true)
  const [isLoading, setIsloading] = useState(false)
  const addsetting = localStorage.getItem('sitSetting')
  const [addCaseSetting, setaddCaseSetting] = useState()

  const access_token = localStorage.getItem('token')

  useEffect(() => {
    socket.emit('websetting')
  }, [])

  useEffect(() => {
    socket.on("websettingGet", (data) => {
      localStorage.setItem("sitSetting", JSON.stringify(data));
      setaddCaseSetting(data);
    });

    socket.on("recive-msg", (msgs) => {
      if (msgs?.sender !== user?._id) addResponseMessage(msgs.text);
    });
  }, []);

  const role = async () => {
    const headers = { Authorization: `Bearer ${access_token}` }
    await axios
      .get(`https://api.rrludo.in/me`, { headers })
      .then(res => {
        setUser(res.data._id)
        setUserAllData(res.data)
        userID.current = res.data._id
        setMount(true)
      })
      .catch(e => {
        if (e.response.status == 401) {
          localStorage.removeItem('token')
        }
        if (e.response.status == 400 || e.response.status == 429) {
          Swal.fire({
            title: 'Please refresh!',
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
      })
  }

  const [game_type, setGame_type] = useState(useLocation().pathname.split('/')[2])
  const [game_type2, setGame_type2] = useState(useLocation().pathname.split('/')[2])
  const [Game_Ammount, setGame_Ammount] = useState('')

  const ChallengeCreate = e => {
    setIsloading(true)
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }

    axios
      .post(
        'https://api.rrludo.in/challange/create',
        { Game_Ammount, Game_type: game_type },
        { headers }
      )
      .then(res => {
        setGame_amt(res?.data?.data?.Game_Ammount)
        if (res.data.status == false) {
          setIsloading(false)
          Swal.fire({ title: res.data.msg, icon: 'warning', confirmButtonText: 'OK' })
        } else if (res.data.msg === 'you have already enrolled') {
          setIsloading(false)
          Swal.fire({ title: 'You have already enrolled', icon: 'warning', confirmButtonText: 'OK' })
        } else if (res.data.msg === 'You can set maximum 2 battle.') {
          setIsloading(false)
          Swal.fire({ title: 'You can set maximum 2 battle.', icon: 'warning', confirmButtonText: 'OK' })
        } else if (res.data.msg === 'Insufficient balance') {
          setIsloading(false)
          Swal.fire({ title: 'Insufficient balance', icon: 'warning', confirmButtonText: 'OK' })
        } else if (res.data.msg === 'Game amount should be Greater then 50 and less then 50000') {
          setIsloading(false)
          Swal.fire({ title: 'Game amount should be Greater then 50 and less then 50000', icon: 'warning', confirmButtonText: 'OK' })
        } else if (res.data.msg === 'Set Battle in denomination of 50') {
          setIsloading(false)
          Swal.fire({ title: 'Set Battle in denomination of 50', icon: 'warning', confirmButtonText: 'OK' })
        } else if (res.data.msg === 'Technical Issue, Try after an hour!') {
          setIsloading(false)
          Swal.fire({ title: 'Technical Issue, Try after an hour!', icon: 'warning', confirmButtonText: 'OK' })
        } else {
          setIsloading(false)
          setGame_Ammount("");
        }
      })
      .catch(e => {
        setIsloading(false)
        if (e?.response?.status == 401) {
          localStorage.removeItem('token')
          window.location.reload()
        }
        if (e?.response?.status == 400 || e?.response?.status == 429) {
          Swal.fire({ title: 'Please refresh!', icon: 'warning', confirmButtonText: 'OK' })
        }
      })
  }

  const [allgame, setallgame] = useState([])
  const [mount, setMount] = useState(false)
  const [runningGames, setRunningGames] = useState([])
  const [ownRunning, setOwnRunning] = useState([])

  const Allgames = async () => {
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }
    axios
      .get('https://api.rrludo.in/challange/all', { headers })
      .then(res => {
        let owenedCreated = [], remainingGame = []
        res.data.forEach(function (ele) {
          if (ele.Created_by._id == user && (ele.Status == 'new' || ele.Status == 'requested')) {
            owenedCreated.push(ele)
          } else {
            remainingGame.push(ele)
          }
        })
        setCreated(owenedCreated)
        setallgame(remainingGame)
      })
  }

  const runningGame = async () => {
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }
    axios
      .get('https://api.rrludo.in/challange/running/all', { headers })
      .then(res => {
        let owenedRunning = [], remainingRunning = []
        res.data.forEach(function (ele) {
          if (ele.Created_by && ele.Accepetd_By)
            if (ele.Created_by?._id == userID.current || ele.Accepetd_By?._id == userID.current) {
              owenedRunning.push(ele)
            } else {
              remainingRunning.push(ele)
            }
        })
        setOwnRunning(owenedRunning)
        setRunningGames(remainingRunning)
      })
  }

  function winnAmount(gameAmount) {
    let profit = 0;
    const commissionLudo = addCaseSetting?.commissionRangeludo || 10;
    const commissionAbove500 = addCaseSetting?.commissionRange2 || 5;
    if (gameAmount >= 50 && gameAmount <= 450) {
      profit = (gameAmount * commissionLudo) / 100;
    } else if (gameAmount > 450) {
      profit = (gameAmount * commissionAbove500) / 100;
    }
    return gameAmount - profit;
  }

  useEffect(() => {
    io.on('gamelist', data => {
      let owenedCreated = [], remainingGame = []
      data.forEach(function (ele) {
        if (ele.Created_by)
          if (ele.Created_by._id == userID.current && (ele.Status == 'new' || ele.Status == 'requested')) {
            owenedCreated.push(ele)
          } else {
            remainingGame.push(ele)
          }
      })
      setCreated(owenedCreated)
      setallgame(remainingGame)
    })

    io.on('resultUpdateReq', data => {
      let owenedRunning = [], remainingRunning = []
      data.forEach(function (ele) {
        if (ele.Created_by && ele.Accepetd_By)
          if (ele.Created_by._id == userID.current || ele.Accepetd_By._id == userID.current) {
            owenedRunning.push(ele)
          } else {
            remainingRunning.push(ele)
          }
      })
      setOwnRunning(owenedRunning)
      setRunningGames(remainingRunning)
      walletUpdate()
    })

    io.on('startAcepptor', data => {
      let owenedCreated = [], remainingGame = []
      data.forEach(function (ele) {
        if (ele.Created_by)
          if (ele.Created_by._id == userID.current && (ele.Status == 'new' || ele.Status == 'requested')) {
            owenedCreated.push(ele)
          } else {
            remainingGame.push(ele)
          }
      })
      setCreated(owenedCreated)
      setallgame(remainingGame)
      walletUpdate()
    })

    io.on('acceptor_seen', data => {
      let owenedCreated = [], remainingGame = []
      data.openBattle.forEach(function (ele) {
        if (ele.Created_by)
          if (ele.Created_by._id == userID.current && (ele.Status == 'new' || ele.Status == 'requested')) {
            owenedCreated.push(ele)
          } else {
            remainingGame.push(ele)
          }
      })
      setCreated(owenedCreated)
      setallgame(remainingGame)
      let owenedRunning = [], remainingRunning = []
      data.runningBattle.forEach(function (ele) {
        if (ele.Created_by && ele.Accepetd_By)
          if (ele.Created_by._id == userID.current || ele.Accepetd_By._id == userID.current) {
            owenedRunning.push(ele)
          } else {
            remainingRunning.push(ele)
          }
      })
      setOwnRunning(owenedRunning)
      setRunningGames(remainingRunning)
      walletUpdate()
    })
  }, [io])

  useEffect(() => {
    let access_token = localStorage.getItem('token')
    if (!access_token) {
      window.location.reload()
    }
    role()
    if (mount) {
      Allgames()
      runningGame()
    }
  }, [mount])

  const AcceptChallang = id => {
    if (str == 1) {
      Swal.fire({ title: 'Other request in process', icon: 'warning', confirmButtonText: 'OK' })
    }
    str = 1
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }
    axios
      .put(
        `https://api.rrludo.in/challange/accept/${id}`,
        { Accepetd_By: headers, Acceptor_by_Creator_at: Date.now() },
        { headers }
      )
      .then(res => {
        setGameData({ accept_by: res.data.Accepetd_By, created_by: res.data.Created_by })
        str = 0
        if (res.data.status === false) {
          Swal.fire({ title: res.data.msg, icon: 'warning', confirmButtonText: 'OK' })
        }
      })
  }

  const RejectGame = id => {
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }
    axios.put(`https://api.rrludo.in/challange/reject/${id}`, { Accepetd_By: null, Status: 'new', Acceptor_by_Creator_at: null }, { headers })
  }

  const deleteChallenge = _id => {
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }
    axios.delete(`https://api.rrludo.in/challange/delete/${_id}`, { headers })
      .then(res => {
        if (res.data.status == false) {
          Swal.fire({ title: res.data.msg, icon: 'warning', confirmButtonText: 'OK' })
        }
      })
  }

  const updateChallenge = _id => {
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }
    axios.put(`https://api.rrludo.in/challange/running/update/${_id}`, { Acceptor_seen: true }, { headers })
  }

  const getPost = async Id => {
    if (game_type === 'Ludo Classics' || game_type === 'Ludo 1 Goti' || game_type === 'Ludo Ulta' || game_type === 'Ludo Host') {
      if (submitProcess) {
        setProcess(false)
        setChallangeReqRun(true)
        const access_token = localStorage.getItem('token')
        const headers = { authorization: `Bearer ${access_token}` }
        axios.patch(`https://api.rrludo.in/challange/requested/running/${game_type}/${Id}`, {}, { headers })
          .then(res => {
            setProcess(true)
            setChallangeReqRun(false)
            if (res.data.status == false) {
              Swal.fire({ title: res.data.msg, icon: 'warning', confirmButtonText: 'OK' })
            } else {
              localStorage.setItem('timeOver', 'timeStart')
              history.push(`/viewgame1/${Id}`, { prevPath: window.location?.pathname })
            }
          })
          .catch(() => { setProcess(true); setChallangeReqRun(false); })
      }
    } else if (game_type === 'LudoSnake' || game_type === 'Ludo Popular' || game_type === 'ludoClassicManual') {
      if (submitProcess) {
        setProcess(false)
        setChallangeReqRun(true)
        const access_token = localStorage.getItem('token')
        const headers = { authorization: `Bearer ${access_token}` }
        axios.patch('https://api.rrludo.in/challange/requested/running/' + Id, {}, { headers })
          .then(res => {
            setProcess(true)
            setChallangeReqRun(false)
            if (res.data.status == false) {
              Swal.fire({ title: res.data.msg, icon: 'warning', confirmButtonText: 'OK' })
            } else {
              localStorage.setItem('timeOver', 'timeStart')
              history.push(`/viewgame1/${Id}`, { prevPath: window.location?.pathname })
            }
          })
          .catch(() => { setProcess(true); setChallangeReqRun(false); })
      }
    }
  }

  const [siteSetting, setsiteSetting] = useState([])
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem('sitSetting'))
    if (items) setsiteSetting(items)
  }, [])

  const [botTable, setBotTable] = useState([]);
  const getRandomSet = async () => {
    try {
      const access_token = localStorage.getItem("token");
      const res = await axios.get("https://api.rrludo.in/randomset", {
        headers: { Authorization: `Bearer ${access_token}` },
      });
      if (res.data.status === "success") setBotTable(res.data.players);
    } catch (err) { console.error("Error fetching random set:", err); }
  };

  useEffect(() => { getRandomSet(); }, []);

  // --- UI THEME STYLES (LIGHT YELLOW, ORANGE, BLACK) ---
  const styles = {
    mainBg: {
      background: '#FFFDE7', // Light Yellow
      minHeight: '100vh',
      color: '#000',
      fontFamily: "'Poppins', sans-serif"
    },
    ticker: {
      background: '#000',
      borderBottom: '2px solid #FF9800',
      padding: '12px 0',
      color: '#FF9800', // Orange Text
      fontSize: '13px',
      fontWeight: '800'
    },
    createCard: {
        background: '#fff',
        borderRadius: '24px',
        padding: '25px',
        border: '1px solid #FFF9C4',
        boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
        marginBottom: '30px'
    },
    inputWrapper: {
        background: '#F5F5F5',
        borderRadius: '16px',
        padding: '5px 5px 5px 20px',
        display: 'flex',
        alignItems: 'center',
        marginTop: '15px',
        border: '2px solid transparent'
    },
    setBtn: {
        background: 'linear-gradient(90deg, #FF9800 0%, #FB8C00 100%)',
        color: '#000',
        border: 'none',
        borderRadius: '12px',
        padding: '12px 25px',
        fontWeight: '900',
        fontSize: '14px',
        marginLeft: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(255,152,0,0.3)'
    },
    sectionHeading: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '16px',
        fontWeight: '900',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '20px',
        paddingLeft: '12px',
        borderLeft: '5px solid #FF9800',
        color: '#000'
    }
  };

  return (
    <>
      <Header user={userAllData} />
      <div className='leftContainer' style={styles.mainBg}>
        <div className='pt-3 mt-5 Orher_page_main_section'>
          
          {/* Theme Ticker */}
          <div style={styles.ticker}>
            <marquee scrollamount="6">
              <BsLightningChargeFill className="me-2" /> 
              {siteSetting?.ludoClassicsMsg || "Welcome to Brothers Ludo - Professional Battles Active Now!"} 
              • INSTANT PAYOUTS • FAIR PLAY GUARANTEED
            </marquee>
          </div>

          <div className='container py-4'>
            <div className='row'>
              <div className='col-lg-8 col-md-12'>
                
                <div className='d-flex justify-content-end mb-3'>
                  <Link to="/Rules" style={{background: '#000', color: '#FF9800', padding: '6px 20px', borderRadius: '10px', fontSize: '12px', fontWeight: '800', textDecoration: 'none'}}>
                    VIEW RULES
                  </Link>
                </div>

                {/* Create Battle Section */}
                {(siteSetting?.gameSearch) && (
                  <div style={styles.createCard}>
                      <h5 style={{fontWeight: '900', margin: 0}}>Create New Battle</h5>
                      <div style={styles.inputWrapper}>
                          <span style={{color: '#000', fontWeight: '900', fontSize: '20px'}}>₹</span>
                          <input
                              type="text"
                              placeholder="Enter Battle Amount"
                              inputMode="numeric"
                              value={Game_Ammount}
                              onChange={e => setGame_Ammount(e.target.value)}
                              style={{background: 'transparent', border: 'none', color: '#000', width: '100%', padding: '12px', outline: 'none', fontWeight: '800', fontSize: '18px'}}
                          />
                          {isLoading ? (
                              <div className="px-4"><Spinner size="sm" animation="border" style={{color: '#FF9800'}} /></div>
                          ) : (
                              <button style={styles.setBtn} onClick={(e) => { e.preventDefault(); ChallengeCreate(); }}>
                                  SET 
                              </button>
                          )}
                      </div>
                  </div>
                )}

                {/* Open Battles List */}
                <div className="mb-5">
                  <div style={styles.sectionHeading}>
                      <span><BsFire color="#FF9800" className="me-2"/> Open Battles</span>
                      <small style={{fontSize: '10px', opacity: 0.5}}>ACTIVE NOW</small>
                  </div>
                  <div className="battle-stack">
                      {created && created.map(allgame => 
                        allgame.Game_type == game_type && (
                          <BetCard key={allgame._id} allgame={allgame} user={user} deleteChallenge={deleteChallenge} getPost={getPost} RejectGame={RejectGame} challangeReqRun={challangeReqRun} winnAmount={winnAmount} AcceptChallang={AcceptChallang} updateChallenge={updateChallenge} />
                        )
                      )}
                      {allgame && allgame.map(allgame => 
                        (allgame.Status == 'new' || (allgame.Status == 'requested' && (user == allgame.Created_by._id || user == allgame?.Accepetd_By?._id)) || (allgame?.Status == 'running' && user == allgame?.Accepetd_By?._id && allgame.Acceptor_seen == false)) &&
                        allgame.Game_type == game_type && (
                          <BetCard key={allgame._id} allgame={allgame} user={user} deleteChallenge={deleteChallenge} getPost={getPost} RejectGame={RejectGame} winnAmount={winnAmount} AcceptChallang={AcceptChallang} updateChallenge={updateChallenge} />
                        )
                      )}
                  </div>
                </div>

                {/* Running Battles List */}
                <div className="mb-5">
                  <div style={styles.sectionHeading}>
                      <span><MdOutlineSportsEsports color="#000" className="me-2" size={22}/> Ongoing Battles</span>
                  </div>
                  <div className="battle-stack">
                      {ownRunning && ownRunning.map(runnig => {
                        if (((user == runnig.Accepetd_By._id ? (runnig.Status === 'running' && user == runnig.Accepetd_By._id && runnig.Acceptor_seen == true) || runnig.Status === 'pending' : (runnig.Status === 'running' && user == runnig.Created_by._id) || runnig.Status === 'pending') || runnig.Status == 'conflict') && runnig.Game_type == game_type)
                        return ( <RunningCard key={runnig._id} runnig={runnig} user={user} winnAmount={winnAmount} /> )
                      })}

                      {runningGames && runningGames.map(runnig => {
                        if ((user == runnig.Accepetd_By._id || user == runnig.Created_by._id ? user == runnig.Accepetd_By._id ? (runnig.Status === 'running' && user == runnig.Accepetd_By._id && runnig.Acceptor_seen == true) || (runnig.Status === 'pending' && runnig.Acceptor_status == null) : (runnig.Status === 'running' && user == runnig.Created_by._id) || (runnig.Status === 'pending' && runnig.Creator_Status == null) : runnig.Status === 'running' || runnig.Status === 'pending') && runnig.Game_type == game_type)
                        return ( <RunningCard key={runnig._id} runnig={runnig} user={user} winnAmount={winnAmount} /> )
                      })}

                      {botTable && botTable.map((running, index) => (
                        <BotTable key={index} running={running} winnAmount={winnAmount} />
                      ))}
                  </div>
                </div>

              </div>

              <div className='col-lg-4 d-none d-lg-block'>
                <Rightcontainer />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .battle-stack { display: flex; flex-direction: column; gap: 14px; }
        input::placeholder { color: #aaa; font-weight: 500; font-size: 15px; }
        .Orher_page_main_section { min-height: 85vh; }
        marquee { display: block; width: 100%; }
        /* Smooth scale effect on card focus */
        div[style*="createCard"]:focus-within { border-color: #FF9800 !important; }
      `}</style>
    </>
  )
}